import { fetchUserInfo } from '@/appsync/service/LoginUserQueryService';
import {
  fetchAuthQuery,
  AuthQueryParam,
} from '@/appsync/service/productAuthQueryService';
import { i18n } from '@/plugins/i18n/i18n';
import { getUserRolePermissions } from '@/services/role/roleService';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import { LoginInfo, UserInfo, ProductAdditionalQueryMap } from '@/types/type';

type Option = {
  forceReload?: {
    userInfo?: boolean;
    productAdditionalQueryMap?: boolean;
  };
};

export const refreshStores = async (
  loginInfo: LoginInfo,
  option?: Option
): Promise<void> => {
  if (!loginUserModule.isLoaded) {
    await loadUserInfo(loginInfo);
    await loadProductAdditionalQueryMap(loginInfo);
  }
  if (!loginUserModule.isPermissionsLoaded) {
    await loadUserPermissions(loginInfo);
  }
  if (option && option.forceReload) {
    if (option.forceReload.userInfo) {
      await loadUserInfo(loginInfo);
    }
  }
};

export const refreshStoresOnLoaded = async (
  userInfo: UserInfo,
  productAdditionalQueryMap: ProductAdditionalQueryMap
): Promise<void> => {
  if (!loginUserModule.isLoaded) {
    loadUserInfoOnLoaded(userInfo);
    if (commonModule.cognitoInfo) {
      loginUserModule.setProductAdditionalQueryMap(productAdditionalQueryMap);
    }
  }
  if (!loginUserModule.isPermissionsLoaded) {
    // ログイン情報から権限をロードする
    await loadUserPermissions(commonModule.loginInfo);
  }
};

const loadUserInfo = async (loginInfo: LoginInfo): Promise<void> => {
  const userInfo: UserInfo = await fetchUserInfo(loginInfo);
  if (!userInfo.userName) {
    userInfo.userName = commonModule.loginName;
  }
  loginUserModule.setUserInfo(userInfo);
  i18n.locale = userInfo.language;
};

const loadUserInfoOnLoaded = (userInfo: UserInfo): void => {
  if (!userInfo.userName) {
    userInfo.userName = commonModule.loginName;
  }
  loginUserModule.setUserInfo(userInfo);
  i18n.locale = userInfo.language;
};

const loadUserPermissions = async (loginInfo: LoginInfo): Promise<void> => {
  const permissions = await getUserRolePermissions(
    loginInfo.loginName,
    loginInfo.tenant,
    loginInfo.landscape
  );
  loginUserModule.setPermissions(permissions);
};

const loadProductAdditionalQueryMap = async (
  loginInfo: LoginInfo
): Promise<void> => {
  if (commonModule.cognitoInfo) {
    const authQueryParam: AuthQueryParam = {
      ...loginInfo,
      identityProvider: commonModule.cognitoInfo.identityProvider,
    };
    const result: ProductAdditionalQueryMap = await fetchAuthQuery(
      authQueryParam
    );
    loginUserModule.setProductAdditionalQueryMap(result);
  }
};
